// @ts-nocheck
import { Action, AnyAction, createSlice } from '@reduxjs/toolkit';
export const initialState = {
	selectedRole: null,
};

interface RejectedAction extends Action {
	error: Error;
}

function isRejectedAction(action: AnyAction): action is RejectedAction {
	return action.type.endsWith('rejected');
}

const slice = createSlice({
	name: 'roles',
	initialState,
	reducers: {
		updateSelectedRole: (state, { payload: { selectedRole } }) => {
			return {
				...state,
				selectedRole,
			};
		},
	},
});

export default slice;

export const { updateSelectedRole } = slice.actions;
